;(function() {
  'use strict'

  angular.module('app.core').component('channelBasicCode', {
    controller: Controller,
    templateUrl: 'channel-basic-code.html',
    bindings: {
      channel: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.toggle = toggle

    function onInit() {
      ctrl.enabled = !!ctrl.channel.basic
    }

    function toggle() {
      ctrl.enabled = !ctrl.enabled

      if (!ctrl.enabled) {
        ctrl.temp = ctrl.channel.basic
        ctrl.channel.basic = null
      } else if (ctrl.temp) {
        ctrl.channel.basic = ctrl.temp
      }
    }
  }
})()
